import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsMenus from "../generic-nav-bar/NavbarIconsMenus";
import { menuStartRegister } from "../../app/actions/menuActions";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import { schemaValidateMenusList } from "../../app/data/schemaValidateMenusList";
import ViewLabel from "../generic-component/ViewLabel";
import NewInputGeneric from "../generic-component/NewInputGeneric";
import NewRelationGeneric from "../generic-component/NewRelationGeneric";
import NewTextGeneric from "../generic-component/NewTextGeneric";
import EditYearGeneric from "../generic-component/EditYearGeneric";
import NewDateGeneric from "../generic-component/NewDateGeneric";
import NewCatalogRelationGeneric from "../generic-component/NewCatalogRelationGeneric";
import NewCatalogLocationGeneric from "../generic-component/NewCatalogLocationGeneric";
import NewCatalogRelationGenericField from "../generic-component/NewCatalogRelationGenericField";
import NewCatalogRelationGenericMenu from "../generic-component/NewCatalogRelationGenericMenu";
import { useNavigate } from "react-router-dom";

const ID_FORM = "admin-menu";
const OPERATION = "register";

const NewMenus = () => {
  debugLogPages(':: NewMenus'); 

    const navigate = useNavigate();

  const dispatch = useDispatch();
  const { menu } = useSelector((state) => state.menu);
  const { t } = useTranslation();

    const { menusFull } = useSelector((state) => state.menu);
  
    const { catalogModules } = useSelector((state) => state.catalogModule);
  
    const { catalogRoles } = useSelector((state) => state.catalogRole);

  const { values, errors, handleChange, handleSubmit, handleChangeCatalogCiiu,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeLocation, handleChangeSingleCatalog, setValues } = useFormValidationsGeneric(
      () => menuCallback(),
      menu,
      schemaValidateMenusList
    );

    useEffect(() => {
      setValues((values) => ({ ...values, 'icon': 'fab fa-firstdraft'}));
      setValues((values) => ({ ...values, 'showicon': false}));

    }, [])

    useEffect(() => {
        
        if (values) {
          handleChange(getObjectById(values.parent_id, menusFull), "parent_id");
          handleChange(getObjectById(values.catalogmodule_id, catalogModules), "catalogmodule_id");
          handleChange(getObjectById(values.catalogrole_id, catalogRoles), "catalogrole_id");
    
        }
    
      }, [menusFull, catalogModules, catalogRoles])

      const getObjectById = (id, arraySearch) => {
        const elementFound = arraySearch.find((ser) => ser.id === id);
        return elementFound;
      };
    
      const getMethodData = (currentData) => {
        let comboData = [];
        let level = 0;
    
        if (currentData === "parent_id") {
          comboData = menusFull;
          level = 1;
        }else if (currentData === "catalogmodule_id") {
          comboData = catalogModules;
          level = 1;
        }else if (currentData === "catalogrole_id") {
          comboData = catalogRoles;
          level = 1;
        }
    
        return { comboData, level };
      };

  const menuCallback = () => {
    debugLogPages(':: NewMenus, menuCallback, values', {values}); 

    let valuesSubmit = { ...values };

    valuesSubmit.deleted = false;
    valuesSubmit.activate = true;

    debugLogPages(':: NewMenus, menuCallback, valuesSubmit', {valuesSubmit}); 
    dispatch(menuStartRegister(valuesSubmit, navigate));

  };

  debugLogPages(':: NewMenus', {errors}); 
  debugLogPages(':: NewMenus', {values}); 

  return (
    <div>
      <NavbarIconsMenus page={"newMenus"} />
      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>

            {/* Formulario dinamico*/}

            <div className="row boxContent">
              {
                schemaValidateMenusList && schemaValidateMenusList.length > 0 && (
                  schemaValidateMenusList.map((techSecondary, index) => {

                    let varField = techSecondary.field;
                    let varRelation = techSecondary.key_relation;
                    const { comboData, level } = getMethodData(techSecondary.field);

                    if (techSecondary.component_new === "ViewGroupLabel") {
                      return (
                        <ViewLabel
                          key={techSecondary.id}
                          values={values}
                          errors={errors}
                          values2={varRelation}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_view}
                        />
                      )
                    } if (techSecondary.component_new === "NewInputGeneric") {
                      return (
                        <NewInputGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewRelationGeneric") {
                      return (
                        <NewRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else if (techSecondary.component_new === "NewTextGeneric") {
                      return (
                        <NewTextGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewYearGeneric") {

                      return (
                        <EditYearGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewDateGeneric") {
                      return (
                        <NewDateGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    }else if (techSecondary.component_new === "NewCatalogRelationGenericField") {
                      return (
                        <NewCatalogRelationGenericField
                          key={techSecondary.id}
                          handleChange={handleChangeSingleCatalog}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                          level={level}
                          
                        />
                      );
                    }else if (techSecondary.component_new === "NewCatalogRelationGenericMenu") {
                      return (
                        <NewCatalogRelationGenericMenu
                          key={techSecondary.id}
                          handleChange={handleChangeSingleCatalog}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                          level={level}
                          
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric1") {
                      if (techSecondary.comparable_relation_condition === "CatalogCiius") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogCiiu}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogPhases") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogPhase}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      }
                    } else if (techSecondary.component_new === "NewCatalogLocationGeneric") {
                      return (
                        <NewCatalogLocationGeneric
                          key={techSecondary.id}
                          handleChange={handleChangeLocation}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else {
                      return (
                        <div>
                        </div>
                      )
                    }
                  })
                )
              }
            </div>

            {/* Fin Formulario dinamico */}

            <div className="btnGuardar">
              <input type="submit" value={t("buttons.submit")} className="btn btn-primary" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewMenus;
